import { render } from "./login.vue?vue&type=template&id=3036bbf4&scoped=true"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"

import "./login.vue?vue&type=style&index=0&id=3036bbf4&scoped=true&lang=css"

import exportComponent from "D:\\work\\jyzs\\jyzs-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3036bbf4"]])

export default __exports__